import { render } from "./broadcast_lines_right.svg?vue&type=template&id=0794741f"
const script = {}
script.render = render

export default script